import Schema from './schema'
import itemSchema from './item.schema'

// Custom validator that accepts both String and Number
const stringOrNumber = (value) => {
  if (typeof value === 'undefined') return true
  return typeof value === 'string' || typeof value === 'number'
}

const manpackOrderSchema = new Schema({
  order: [
    {
      employeeId: stringOrNumber,
      addressId: stringOrNumber,
      shippingMethod: stringOrNumber,
      data: itemSchema
    }
  ]
})

export default manpackOrderSchema
